module.exports = __webpack_public_path__ + "static/media/53_B.c8369681.png";